<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="margin: 0 !important"
      >
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Search Username </label>
          <div class="col-sm-4">
            <el-input v-model="searchParam.userName" clearable></el-input>
          </div>
          <div class="form-group">
            <el-button @click="handleSearchList" type="primary">{{ $t("message.Search") }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content m-b-sm border-bottom">
      <div
        class="row table-responsive"
        style="padding-bottom: 20px; margin: 0 !important"
      >
        <div class="content-head">
          <div class="btn-wrap">
            <div style="margin-right:10px;">
                <el-button @click="handleNavToDetail">
                    {{ $t("message.Add") }}
                </el-button>
            </div>
          </div>
          <div class="col-xs-12">{{total}} {{ $t("message.datagridresult") }}</div>
        </div>
        <el-table
          :data="accountList"
          sort
          style="width: 100%"
          :fit="true"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="userName"
            label="Username"
          ></el-table-column>
          <el-table-column
            prop="email"
            label="Email"
            min-width="200"
          ></el-table-column>
          <el-table-column
            label="Status"
          >
            <template slot-scope="scope">
              <div>{{statusMap[scope.row.status]}}</div>
            </template>
          </el-table-column>

          <el-table-column label="Edit" width="70" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleNavToDetail(scope.row)"
                icon="el-icon-edit"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="el-table_footertoolbar">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handlePageSizeChange"
            @current-change="handlePageCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParam.pageSize"
            :total="total"
            style="float: right"
          >
          </el-pagination>
        </el-col>
      </div>
      <div class="bottom-button-wrap">
          <el-button 
            size="medium" 
            type="primary" 
            @click="handleSendEmailToAccount"
          >
            Send
          </el-button>
        </div>
    </div>
  </div>
</template>
<script>
import config from "../config";
import axios from "axios"

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      tableSelectedList:[],
      total:0,
      userInfo:{
        userId:null,
        token:''
      },
      accountList: [{
          userName: "",
          email:"",
          verificationCode:"",
          status:0
        }
      ],
      searchParam: {
        userName:'',
        pagesize:10,
        userId:null,
        token:'',
        sortName:"",
        sortType:"",
        pageIndex:1,
        pageSize:10
      }
    }
  },
  watch:{
    userInfo:{
      deep:true,
      handler:function(val){
        const {userId,token} =val
        this.searchParam.userId=userId
        this.searchParam.token=token
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  mounted() {
    this.handleSearchList()
  },
  components: {},
  computed:{
    statusMap(){
      return {
        0:'Inactive',
        1:'Active'
      }
    },
    baseURL(){
      return config.domain+'/'
    }
  },
  methods: {
    getUserInfo(){
      this.userInfo=this.getAuthObj();
    },
    async handleSearchList(){
      const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudgeUser/list', this.searchParam)
      if(status_code=='0') {
        this.total=result.total
        this.accountList=result.judgeUsers
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handleNavToDetail(row) {
      this.$router.push({
        path: "/main/editJudgeAccount",
        query: {
          id: row.id,
        },
      });
    },
    handlePageSizeChange (val){
        this.searchParam.pageSize = val;
        this.handleSearchList()
    },
    handlePageCurrentChange (val){
        this.searchParam.pageIndex = val;
        this.handleSearchList()
    },
    handleSelectionChange(val){
      this.tableSelectedList =val
    },
    async handleSendEmailToAccount(){
      if(!this.tableSelectedList.length) return 
      const ids=this.tableSelectedList.reduce((total,item,index)=>{
        if(index==this.tableSelectedList.length-1) return total+item.id
        return total +item.id +","
      },'')
      const params={
        ids,
        ...this.userInfo
      }
      const formData = new FormData()
      Object.keys(params).forEach(i=>{
        formData.append(i,params[i])
      })
       const {data:{result,status_code,status_message}}=await axios.post(this.baseURL +'stemupJudgeUser/sendMail',formData)
      if(status_code=='0') {
        this.$message({
          message: 'Email is successfully sent',
          type: 'success'
        });
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }

    }
  }
};
</script>

<style lang="scss" scoped>
.content-head{
  display:flex;
  flex-direction: column;
  .btn-wrap{
    display: flex;
    justify-content: flex-end;
  }
}   
.bottom-button-wrap{
  display:flex;
  justify-content: flex-end;
  
}
</style>
